import { Directive, ElementRef, Input } from '@angular/core';
import * as $ from 'jquery';


export class AutofocusDirective {

  constructor(el: ElementRef) {
    setTimeout(() => {
      $(el.nativeElement).focus();
    }, 100);
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngAutoFocus]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
